interface ContainerProps {
  children: React.ReactNode;
}

export default function Container({ children }: ContainerProps) {
  return (
    <div className="flex min-h-0 grow flex-col rounded-lg border border-gray-200 bg-white">
      {children}
    </div>
  );
}
